import React from "react";
import Routes from "../src/routes/Routes";
import { MuiThemeProvider } from "@material-ui/core/styles";
import theme from "../src/utils/theme";
import FooterComponet from "./components/layout/footer";
import validarVersion from "./utils/ValidarVersion";
import './index.css'
import { useEffect } from "react";

const App = () => {
  useEffect(() => {
    validarVersion();
  }, [])

  return (
    <MuiThemeProvider theme={theme}>
      <div className="app-container">
        <Routes />
        {window.location.pathname !== '/' &&
          <FooterComponet />}
      </div>
    </MuiThemeProvider>
  );
}

export default App;
